import axiosInstance from "./service-instance";

export default {
    fetchCibilDetails: (status, page, page_size, filters) =>
        axiosInstance.get("/company/cibil-request/list-update/", {
            params: {
                status,
                page,
                page_size,
                filters
            }
        }),
    updateCibilDetails: (data) =>
        axiosInstance.put("/company/cibil-request/list-update/", data),
    
    createCibilRequest: (caseId, associate) =>
        axiosInstance.post(`/company/case/${caseId}/cibil-request/`, {
            associate
        })
};